import enAdmin from './locales/en/admin.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enCommunity from './locales/en/community.json';
import enCourses from './locales/en/courses.json';
import enToasts from './locales/en/toasts.json';

/** Shape of one locale's namespaces (i18next typing). English bundles only in the main entry. */
export const enNamespaces = {
  common: enCommon,
  courses: enCourses,
  toasts: enToasts,
  auth: enAuth,
  admin: enAdmin,
  community: enCommunity,
} as const;

export type I18nResources = typeof enNamespaces;

/** All JSON namespaces under `locales/<lng>/` — keep in sync with filenames. */
export const I18N_NAMESPACE_KEYS = ['common', 'courses', 'toasts', 'auth', 'admin', 'community'] as const;

export type I18nNamespace = (typeof I18N_NAMESPACE_KEYS)[number];
